export default "__VITE_ASSET__BH3lCqi2__"